<template>
  <v-container fluid>
    <v-row class="mb-2" align="center">
      <v-col cols="auto" class="text-h6">Depot</v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-btn small text @click="reload">
          <v-icon left small>mdi-refresh</v-icon>
          Aktualisieren
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="shares"
        :items-per-page="-1"
        :show-expand="true"
        :expanded.sync="expanded"
        item-key="isin"
        sort-by="total_value"
        :sort-desc="true"
        dense
        class="elevation-1 depot-table"
        no-data-text="Keine offenen Positionen"
        @click:row="toggleExpand"
    >
      <template v-slot:item.name="{ item }">
        <div class="font-weight-medium">{{ item.name || item.isin }}</div>
        <div class="text--secondary text-caption">{{ item.isin }}</div>
      </template>

      <template v-slot:item.pieces="{ item }">
        {{ fmtPieces(item.pieces) }}
      </template>

      <template v-slot:item.market_value="{ item }">
        {{ fmtEur(item.market_value) }}
      </template>

      <template v-slot:item.total_value="{ item }">
        <span class="font-weight-medium">{{ fmtEur(item.total_value) }}</span>
      </template>

      <template v-slot:item.acquisitionprice="{ item }">
        {{ fmtEur(item.acquisitionprice) }}
      </template>

      <template v-slot:item.win_abs="{ item }">
        <span :class="gainClass(item.win_abs)">{{ fmtSignedEur(item.win_abs) }}</span>
      </template>

      <template v-slot:item.win_rel="{ item }">
        <span :class="gainClass(item.win_rel)">{{ fmtPct(item.win_rel) }}</span>
      </template>

      <template v-slot:item.win_rel_pa="{ item }">
        <span :class="gainClass(item.win_rel_pa)">{{ fmtPct(item.win_rel_pa) }}</span>
      </template>

      <template v-slot:item.dividende="{ item }">
        {{ fmtEur(item.dividende) }}
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-3 grey lighten-5">
          <div class="text-subtitle-2 mb-2">Kauf-Tranchen ({{ item.purchases.length }})</div>
          <v-simple-table dense>
            <thead>
            <tr>
              <th class="text-left">Datum</th>
              <th class="text-right">Stücke</th>
              <th class="text-right">Preis / Stück</th>
              <th class="text-right">Kosten</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="p in item.purchases" :key="p.id">
              <td>{{ fmtDate(p.purchase_date) }}</td>
              <td class="text-right">{{ fmtPieces(p.pieces) }}</td>
              <td class="text-right">{{ fmtEur(p.price_per_piece) }}</td>
              <td class="text-right">{{ fmtEur(p.pieces * p.price_per_piece) }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {fmtDate, fmtEur, fmtSignedEur, fmtPct, fmtPieces, gainClass} from "./finanzenFormat";

export default {
  name: "DepotView",
  data: () => ({
    expanded: [],
    headers: [
      {text: "Name / ISIN", value: "name"},
      {text: "Stücke", value: "pieces", align: "end"},
      {text: "Kurs", value: "market_value", align: "end"},
      {text: "Gesamt", value: "total_value", align: "end"},
      {text: "Einstand", value: "acquisitionprice", align: "end"},
      {text: "G/V", value: "win_abs", align: "end"},
      {text: "G/V %", value: "win_rel", align: "end"},
      {text: "p.a.", value: "win_rel_pa", align: "end"},
      {text: "Dividenden", value: "dividende", align: "end"},
      {text: "", value: "data-table-expand"},
    ],
  }),
  computed: {
    shares() {
      return this.$store.state.smarthaus.finanzen.shares
    },
  },
  methods: {
    fmtDate, fmtEur, fmtSignedEur, fmtPct, fmtPieces, gainClass,
    toggleExpand(item, slot) {
      slot.expand(!slot.isExpanded)
    },
    reload() {
      this.$store.dispatch('update', {"context": '/shares'})
    },
  },
  mounted() {
    this.reload()
  },
}
</script>

<style scoped>
.depot-table ::v-deep tbody tr:not(.v-data-table__expanded__content) {
  cursor: pointer;
}
</style>
